import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


export default function initFunFacts() {
	const blocks = document.querySelectorAll('.fun-facts');

	blocks.forEach(block => {
		if (block.dataset.initialized) return;
		block.dataset.initialized = 'true';

		const funFactsSwiper = new Swiper(block.querySelector('.swiper'), {
			modules: [Navigation],
			slidesPerView: "auto",
			spaceBetween: 16,
			loop: false,
			navigation: {
				nextEl: block.querySelector('.swiper-button-next'),
				prevEl: block.querySelector('.swiper-button-prev'),
			},
		});

	});
}